module.exports = __webpack_public_path__ + "img/logoVertical.d8f53d21.png";